// extracted by mini-css-extract-plugin
export var borderRadius = "_a4-4";
export var large = "_a4-3";
export var logoContainer = "_a4-0";
export var nameLogo = "_a4-2";
export var small = "_a4-1";